module.exports = __webpack_public_path__ + "static/media/sitting.4ba99e67.mp3";